



export const navLinks = [
    {
      id: "about",
      title: "About Us",
    },
    {
      id: "calendar",
      title: "Events",
    },
    {
      id: "embedcalendar",
      title: "Calendar",
    },
    {
      id:"alumni",
      title:"Alumni"
    }
  ];